import React from 'react';
import { Circle } from '@chakra-ui/react';

export const OrCondition = React.memo(() => {
  return (
    <Circle
      background="teal.500"
      fontSize={{ sm: '2xl', lg: '3xl' }}
      width={{ base: '28px', sm: '36px', lg: '48px' }}
      height={{ base: '28px', sm: '36px', lg: '48px' }}
      color="white"
      fontWeight="bold"
      mt={{ base: 5, sm: 6, md: 0 }}
      mb={{ base: 1, sm: 2, md: 0 }}
    >
      或
    </Circle>
  );
});
